import { useCallback, useState } from 'react'

import { ContentType, curateContent } from '@/utils/curation'
import { CustomError } from '@/utils/helpers'

import useSpacesAuthAdmin from './useSpacesAuthAdmin'

interface ContentCurationHook {
  curate: (contentType: ContentType, contentId: string, hide: boolean) => Promise<void>
  isLoading: boolean
  error: CustomError
}

const useContentCuration = (): ContentCurationHook => {
  // Hooks
  const { token } = useSpacesAuthAdmin()

  // State
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<CustomError>({
    call: 'useContentCurationAdmin',
    msg: undefined,
    isError: false,
  })

  // Curate content
  const curate = useCallback(
    async (contentType: ContentType, contentId: string, hide: boolean) => {
      if (!token) return
      setIsLoading(true)
      const [, err] = await curateContent(token, contentType, contentId, hide)
      setIsLoading(false)
      if (err.isError) setError(err)
    },
    [token]
  )

  return {
    curate,
    isLoading,
    error,
  }
}

export default useContentCuration
